<div class="group1">
  <h4 style="margin-top: 0;" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!hidetitle"> Général </h4>
  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt1">
    <label class="col-sm-3 champ" style="padding:0px">Enseigne :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit">
        {{common.visibleChamp.cltObj1.vision ? (detail.enseigne || '-') : ''}}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [(ngModel)]="detail.enseigne" [hidden]="!common.visibleChamp.cltObj1.vision"
        [disabled]="(add && !common.visibleChamp.cltObj1.creation) || (!add && edit && !common.visibleChamp.cltObj1.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt2">
    <label class="col-sm-3 champ" style="padding:0px">Civilité :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <!-- <div  [ngClass]="{'disabledbutton': detail.prospectHolding }"  *ngIf="!edit">{{ civilite }}</div> -->
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj2.vision">
        {{ (detail.civilite ? detail.civilite.libelle || civilite : 'Aucune')
        }}
      </div>
      <div
        [ngClass]="{'disabledbutton': detail.prospectHolding, 'disabledbutton': (add && !common.visibleChamp.cltObj2.creation) || (!add && edit && !common.visibleChamp.cltObj2.modifiable) }"
        *ngIf="edit">
        <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj2.vision">
          <app-autocomplete (searchfunction)="searchCivilite($event)"
            (selectfunction)="detail.civilite = $event; change.cltObj2 = true;" [results]="listCivilite"
            [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.civilite"
            [disablefocus]="true"
            [defaultsearch]="common.visibleChamp.cltObj2.vision || (!common.visibleChamp.cltObj2.vision && change.cltObj2) ? (detail.civilite ? detail.civilite.libelle : 'Aucune') : ''">
          </app-autocomplete>
        </div>
        <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj2.vision">
          {{ (detail.civilite ? detail.civilite.libelle : 'Aucune')}}
        </div>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt170">
    <label class="col-sm-3 champ" style="padding:0px">
      Nom
      <span class="champobligatoire"> * </span> :

    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && common.visibleChamp.cltObj170.vision">
        {{(detail.nomClient)}}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [(ngModel)]="detail.nomClient" (ngModelChange)="change.cltObj170 = true;"
        [hidden]="!common.visibleChamp.cltObj170.vision"
        [disabled]="!droit.droitFicheGen || (add && !common.visibleChamp.cltObj170.creation) || (!add && edit && !common.visibleChamp.cltObj170.modifiable) || masqueModificationExterne">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt158">
    <label class="col-sm-3 champ" style="padding:0px">Prénom
      <span class="champobligatoire" *ngIf="isprenomObligatoire"> * </span> :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && common.visibleChamp.cltObj158.vision">
        {{detail.prenom }}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [(ngModel)]="detail.prenom" (ngModelChange)="change.cltObj158 = true;"
        [hidden]="!common.visibleChamp.cltObj158.vision"
        [disabled]="!droit.droitFicheGen || (add && !common.visibleChamp.cltObj158.creation) || (!add && edit && !common.visibleChamp.cltObj158.modifiable) || masqueModificationExterne">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt176 && !detail.prospect">
    <label class="col-sm-3 champ" style="padding:0px">
      Code
      <span class="champobligatoire" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!isCodeClientAuto">
        * </span> :

    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && common.visibleChamp.cltObj176.vision">
        {{ detail.codeClient }}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text"
        [hidden]="!common.visibleChamp.cltObj176.vision" [readonly]="isCodeClientAuto || detail.id" class="form-control"
        [(ngModel)]="detail.codeClient" (ngModelChange)="change.cltObj176 = true;"
        [disabled]="!droit.droitFicheGen
                || (add && !common.visibleChamp.cltObj176.creation) || (!add && edit && !common.visibleChamp.cltObj176.modifiable) || masqueModificationExterne">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="detail.prospect">
    <label class="col-sm-3 champ" style="padding:0px">
      Code prospect :
      <span class="champobligatoire" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!codeProspectAuto">
        * </span> :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit">{{detail.codeProspect }}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text"
        [readonly]="societe.codeProspectAuto" class="form-control" [(ngModel)]="detail.codeProspect"
        [disabled]="!droit.droitFicheGen || masqueModificationExterne">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt5">
    <label class="col-sm-3 champ" style="padding:0px">Date de création :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj5.vision">
        {{ (detail.dateCreation ?
        ((detail.dateCreation.slice(0, -9) !== '01/01/2000') ?
        detail.dateCreation.slice(0,
        -9) : '') : '') }}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" readonly
        [hidden]="!common.visibleChamp.cltObj5.vision" class="form-control" [(ngModel)]="detail.dateCreation"
        (ngModelChange)="change.cltObj5 = true; common.changeDateFormat('dateCreation', detail)"
        [disabled]="!droit.droitFicheGen ||
                 (add && !common.visibleChamp.cltObj5.creation) || (!add && edit && !common.visibleChamp.cltObj5.modifiable)">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt26">
    <label class="col-sm-3 champ" style="padding:0px">Type :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">

      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj26.vision">
        {{(detail.type ? (detail.type.typeclient || detail.type.libelle) : '') }}
      </div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit">
        <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj26.vision && !masqueModificationExterne"
          [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj26.creation) || (!add && edit && !common.visibleChamp.cltObj26.modifiable) }">
          <app-autocomplete (searchfunction)="searchType($event)" (selectfunction)="detail.type = $event"
            [results]="result" [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.type"
            [disablefocus]="true" [defaultsearch]="detail.type ? (detail.type.typeclient || detail.type.libelle) : ''">
          </app-autocomplete>
        </div>
        <div *ngIf="(!droit.droitFicheGen || masqueModificationExterne) && common.visibleChamp.cltObj26.vision">
          {{ (detail.type ? (detail.type.typeclient || detail.type.libelle) : '')}}
        </div>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="common.visibleChamp.clt205 && societe && societe.gestionClientHolding && societe.isFactIntersociete &&
         common.activedModule != 4">
    <label class="col-sm-3 champ" style="padding:0px"> Soc. Fact :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && common.visibleChamp.cltObj205.vision">
        {{ (detail.holdingSocieteFille ? (detail.holdingSocieteFille.libelle || detail.holdingSocieteFille.nom)
        : '') }}
      </div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit">
        <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj26.vision"
          [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj26.creation) || (!add && edit && !common.visibleChamp.cltObj26.modifiable) }">
          <app-autocomplete (selectfunction)="detail.holdingSocieteFille = $event" [results]="listeSociete || []"
            [highlight]="true" [id]="'modedepaie'" [showonFoscus]="true" [defaultselected]="detail.holdingSocieteFille"
            [disablefocus]="true" [isCombo]="true"
            [defaultsearch]="detail.holdingSocieteFille ? (detail.holdingSocieteFille.libelle ||  detail.holdingSocieteFille.nom) : ''">
          </app-autocomplete>
        </div>
        <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj205.vision">
          {{ (detail.holdingSocieteFille ? (detail.holdingSocieteFille.libelle ||
          detail.holdingSocieteFille.nom) : '') }}
        </div>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt228 && !isInfoPart">
    <label class="col-sm-3 champ" style="padding:0px"> Agence : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj228.vision" class="col-sm-12" style="padding: 0;"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj228.creation) || (!add && edit && !common.visibleChamp.cltObj228.modifiable) }">
        <div class="" style="padding: 0px;"
          [ngClass]="{'col-sm-8': agence && agence.id, 'col-sm-10': !agence || (agence && !agence.id)}">
          <app-autocomplete (selectfunction)="agence = $event" [placeholder]="'Taper pour rechercher'"
            [results]="resultAgence" [highlight]="true" [id]="'modedepaie'" [disablefocus]="true"
            (searchfunction)="searchAgence($event)" [container]="true" [defaultselected]="agence"
            [showResultKeyenter]="true" [defaultsearch]="agence ? agence.libelleObjetEntite : ''"
            [activeVisibleChamp]="true" [visibleChamp]="common.visibleChamp.cltObj228.vision"></app-autocomplete>
        </div>

        <div class="text-right" style="padding: 0px;"
          [ngClass]="{'col-sm-4': agence && agence.id, 'col-sm-2': !agence || (agence && !agence.id)}">
          <button class="btn-add activebtn" id="add" (click)="addAgence()">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
          <button class="btn-add" id="modif" [ngClass]="{'disabledbutton': detail.prospectHolding }"
            *ngIf="agence && agence.id" (click)="editAgence()">
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj228.vision" class="col-sm-12" style="padding: 0;">
        {{ (agence ? agence.libelleObjetEntite : '') }}
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt37 && !isInfoPart">
    <label class="col-sm-3 champ" style="padding:0px">Chantier :</label>
    <div class="col-sm-9 champ  text-underline historique" style="padding-right: 0px">
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj37.vision" class="col-sm-12" style="padding: 0;"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj37.creation) || (!add && edit && !common.visibleChamp.cltObj37.modifiable) }">
        <div class="" style="padding: 0px;" [ngClass]="{'col-sm-8': chantier.id, 'col-sm-10': !chantier.id}">
          <app-autocomplete [placeholder]="'Taper pour rechercher'" (searchfunction)="searchChantier($event)"
            (selectfunction)="getDetailChantier($event)" [results]="listeChantier" [highlight]="true"
            [disablefocus]="true" [container]="true" [label]="''" [defaultselected]="chantier"
            [defaultsearch]="chantier ? (chantier.numChantier || chantier.responsable || chantier.adresse1) : ''"
            [showResultKeyenter]="true" [autohide]="true" [activeVisibleChamp]="true"
            [visibleChamp]="common.visibleChamp.cltObj37.vision"></app-autocomplete>
        </div>

        <div class="text-right" style="padding: 0px;" *ngIf="common.isCMchantier"
          [ngClass]="{'col-sm-4': chantier.id, 'col-sm-2': !chantier.id}">
          <button class="btn-add activebtn" id="add" (click)="addChantier()">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
          <button class="btn-add" id="modif" *ngIf="chantier.id" (click)="editChantier()">
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj37.vision" class="col-sm-12" style="padding: 0;">
        {{ (chantier ? (chantier.numChantier || chantier.responsable || chantier.adresse1) : '') }}
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt6">
    <label class="col-sm-3 champ" style="padding:0px">Tel
      <span class="champobligatoire" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="add"> *
      </span> :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit">
        {{common.visibleChamp.cltObj6.vision ? detail.telephone : ''}}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [hidden]="!common.visibleChamp.cltObj6.vision" [(ngModel)]="detail.telephone"
        [disabled]="!droit.droitFicheGen ||
                (add && !common.visibleChamp.cltObj6.creation) || (!add && edit && !common.visibleChamp.cltObj6.modifiable) || masqueModificationExterne">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt7">
    <label class="col-sm-3 champ" style="padding:0px">Fax :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj7.vision">
        {{ detail.fax }}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [hidden]="!common.visibleChamp.cltObj7.vision" [(ngModel)]="detail.fax"
        [disabled]="!droit.droitFicheGen ||
                (add && !common.visibleChamp.cltObj7.creation) || (!add && edit && !common.visibleChamp.cltObj7.modifiable) || masqueModificationExterne">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt8">
    <label class="col-sm-3 champ" style="padding:0px">Mail :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj8.vision">
        {{ detail.mail }}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [hidden]="!common.visibleChamp.cltObj8.vision" [(ngModel)]="detail.mail"
        (keydown)="common.filterCarracterEmail($event)"
        [disabled]="!droit.droitFicheGen ||
                (add && !common.visibleChamp.cltObj8.creation) || (!add && edit && !common.visibleChamp.cltObj8.modifiable) || masqueModificationExterne">
    </div>
  </div>

  <ng-template>

  </ng-template>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="(common.visibleChamp.clt9) ||
         (common.visibleChamp.clt10) ||
          (common.visibleChamp.clt11)">
    <label class="col-sm-3 champ" style="padding:0px">
      Adresse
      <span class="champobligatoire"> * </span> :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && (common.visibleChamp.clt9 && common.visibleChamp.cltObj9.vision)">
        {{detail.adresse1}}</div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && (common.visibleChamp.clt9 && !common.visibleChamp.cltObj9.vision)">

      </div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && (common.visibleChamp.clt10 && common.visibleChamp.cltObj10.vision)">
        {{ detail.adresse2 }}</div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && (common.visibleChamp.clt10 && !common.visibleChamp.cltObj10.vision)">

      </div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && (common.visibleChamp.clt11 && common.visibleChamp.cltObj11.vision)">
        {{ detail.adresse3 }}</div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && (common.visibleChamp.clt11 && !common.visibleChamp.cltObj11.vision)">

      </div>
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit">
        <div *ngIf="(droit.droitFicheGen && common.visibleChamp.cltObj8.vision) && !masqueModificationExterne">
          <app-autocomplete
            [ngClass]="{'disabledbutton': detail.prospectHolding ||
                    (add && !common.visibleChamp.cltObj8.creation) || (!add && edit && !common.visibleChamp.cltObj8.modifiable) }"
            *ngIf="adresseAutoBAK" [placeholder]="'Adresse'" (searchfunction)="searchAdresseBAK($event)"
            (selectfunction)="setValueAdresseBAK($event, 'client')" [results]="dataAdresseBAK" [container]="true"
            [defaultsearch]="detail.adresse1 ? detail.adresse1 : ''" [minlength]="3" [nePasCompterEspace]="true">
          </app-autocomplete>
        </div>

        <input [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="edit &&  (common.visibleChamp.clt9) && !adresseAutoBAK" [hidden]="!common.visibleChamp.cltObj9.vision"
          type="text" class="form-control" [(ngModel)]="detail.adresse1" [readonly]="adresseAutoBAK"
          style="margin-bottom: 5px;"
          [disabled]="!droit.droitFicheGen ||
                    (add && !common.visibleChamp.cltObj9.creation) || (!add && edit && !common.visibleChamp.cltObj9.modifiable) || masqueModificationExterne">
      </div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && (common.visibleChamp.clt10)"
        type="text" [hidden]="!common.visibleChamp.cltObj10.vision" class="form-control" [(ngModel)]="detail.adresse2"
        autocomplete="off" style="margin-top: 5px; margin-bottom: 5px;" [readonly]="adresseAutoBAK"
        [disabled]="!droit.droitFicheGen ||
                (add && !common.visibleChamp.cltObj10.creation) || (!add && edit && !common.visibleChamp.cltObj10.modifiable) || masqueModificationExterne">
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && (common.visibleChamp.clt11)"
        type="text" [hidden]="!common.visibleChamp.cltObj11.vision" class="form-control" [(ngModel)]="detail.adresse3"
        autocomplete="off" [readonly]="adresseAutoBAK"
        [disabled]="!droit.droitFicheGen ||
                (add && !common.visibleChamp.cltObj11.creation) || (!add && edit && !common.visibleChamp.cltObj11.modifiable) || masqueModificationExterne">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt12">
    <label class="col-sm-3 champ" style="padding:0px">
      CP
      <span class="champobligatoire"> * </span> :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
        *ngIf="!edit && common.visibleChamp.cltObj12.vision ">
        {{detail.codePostal }} </div>
      <div
        [ngClass]="{'disabledbutton': detail.prospectHolding ||
            (add && !common.visibleChamp.cltObj12.creation) || (!add && edit && !common.visibleChamp.cltObj12.modifiable) }"
        *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'codePostal'" [item]="detail" [ville]="'ville'" [iscp]="true"
          [disable]="adresseAutoBAK || !droit.droitFicheGen || masqueModificationExterne" [activeVisibleChamp]="true"
          [visibleChamp]="common.visibleChamp.cltObj12.vision">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt13">
    <label class="col-sm-3 champ" style="padding:0px">
      Ville
      <span class="champobligatoire"> * </span> :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj13.vision">
        {{ detail.ville }} </div>
      <div
        [ngClass]="{'disabledbutton': detail.prospectHolding||
            (add && !common.visibleChamp.cltObj13.creation) || (!add && edit && !common.visibleChamp.cltObj13.modifiable) }"
        *ngIf="edit">
        <app-autocomplete-cp-ville [cp]="'codePostal'" [item]="detail" [ville]="'ville'"
          [disable]="adresseAutoBAK || !droit.droitFicheGen || masqueModificationExterne" [activeVisibleChamp]="true"
          [visibleChamp]="common.visibleChamp.cltObj13.vision">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="adresseAutoBAK">
    <label class="col-sm-3 champ" style="padding:0px">
      Ancienne Ville :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{common.bak.ancienneVille}} </div>
      <div *ngIf="edit">
        <app-autocomplete-cp-ville [item]="common.bak" [ville]="'ancienneVille'" [disable]="adresseAutoBAK">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt14">
    <label class="col-sm-3 champ" style="padding:0px" (click)="test()">Pays :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <!-- <div  [ngClass]="{'disabledbutton': detail.prospectHolding }"  *ngIf="!edit">{{detail.Pays}}</div> -->
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj14.vision">
        {{(detail.paysObjet ? detail.paysObjet.libelle || detail.paysObjet.libelleObjetEntite : '') }}
      </div>
      <div
        [ngClass]="{'disabledbutton': detail.prospectHolding||
            (add && !common.visibleChamp.cltObj14.creation) || (!add && edit && !common.visibleChamp.cltObj14.modifiable) }"
        *ngIf="edit">
        <div *ngIf="droit.droitFicheGen">
          <app-autocomplete (searchfunction)="searchPays($event)" [disablefocus]="true"
            (selectfunction)="detail.paysObjet = $event; detail.Pays = $event.libelle" [results]="listPays"
            [selectvalue]="true" [highlight]="true" [id]="'modedepaie'" [defaultselected]="detail.paysObjet"
            [defaultsearch]="detail.paysObjet ? detail.paysObjet.libelle : ''"></app-autocomplete>
        </div>
        <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj14.vision">
          {{ (detail.paysObjet ? detail.paysObjet.libelle : '') }}
        </div>
      </div>
      <!--input  [ngClass]="{'disabledbutton': detail.prospectHolding }"  *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.Pays"-->
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="societe.clientCollectivite && adresseAutoBAK">
    <label class="col-sm-3 champ" style="padding:0px"> Complément adresse 1 :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit">
        {{ detail.complementAd1 || '' }}
      </div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [(ngModel)]="detail.complementAd1">
    </div>
  </div>


  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="societe.clientCollectivite && adresseAutoBAK">
    <label class="col-sm-3 champ" style="padding:0px"> Complément adresse 2 :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit">
        {{ detail.complementAd2 || '' }}
      </div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [(ngModel)]="detail.complementAd2">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="societe.clientCollectivite && adresseAutoBAK">
    <label class="col-sm-3 champ" style="padding:0px"> Complément adresse 3 :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit">
        {{ detail.complementAd3 || '' }}
      </div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
        [(ngModel)]="detail.complementAd3">
    </div>
  </div>

  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt25">
    <label class="col-sm-3 champ" style="padding:0px">
      SIRET
      <span class="champobligatoire"> * </span> :

    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px; border: 0px;"
      [ngClass]="{'disabledbutton': detail.prospectHolding }"
      popover="Le format du siret doit être de 14 chiffres et ne contient pas d'espace." triggers=""
      [isOpen]="isInfoSiretOpen" containerClass="isInfoSiretOpen">
      <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="!edit && common.visibleChamp.cltObj25.vision">
        {{ (detail.siret) }}</div>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && !societe.isBaseSirene" type="text"
        class="form-control" [hidden]="!common.visibleChamp.cltObj25.vision" [(ngModel)]="detail.siret"
        autocomplete="off"
        [disabled]="!droit.droitFicheGen||
                (add && !common.visibleChamp.cltObj25.creation) || (!add && edit && !common.visibleChamp.cltObj25.modifiable) || masqueModificationExterne">
      <app-autocomplete [placeholder]="'Taper pour rechercher un siren'" *ngIf="edit && societe.isBaseSirene"
        (searchfunction)="searchSiren($event)" (selectfunction)="setValueSiren($event)" [results]="dataSiren"
        [container]="true" [defaultsearch]="''" [minlength]="14" [maxlength]="14" [deleteLibelle]="true"
        (keyUp)="keyUpInputSiret($event)" (blurfunction)="blurInputSiret()" [nePasCompterEspace]="true">
      </app-autocomplete>
      <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && societe.isBaseSirene" type="text"
        class="form-control" [hidden]="!common.visibleChamp.cltObj25.vision" [(ngModel)]="detail.siret"
        autocomplete="off" readonly style="margin-top: 5px;">
    </div>
  </div>

  <ng-template [ngIf]="!isInfoPart">
    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt35">
      <label class="col-sm-3 champ" style="padding:0px"> Decheterie :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <input *ngIf="common.visibleChamp.cltObj35.vision" type="checkbox" id="checkbox-1-1 "
          class="regular-checkbox regular-checkbox-checked" [disabled]="!edit" [(ngModel)]="detail.isEcodechetterie"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj35.creation) || (!add && edit && !common.visibleChamp.cltObj35.modifiable)">

      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt35">
      <label class="col-sm-3 champ" style="padding:0px"> N° Badge :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj35.vision">
          {{ detail.numBadge }}</div>
        <input [hidden]="!common.visibleChamp.cltObj35.vision"
          [ngClass]="{'disabledbutton': detail.prospectHolding||
                (add && !common.visibleChamp.cltObj35.creation) || (!add && edit && !common.visibleChamp.cltObj35.modifiable) }" *ngIf="edit" type="text"
          class="form-control" [(ngModel)]="detail.numBadge">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt180">
      <label class="col-sm-3 champ" style="padding:0px"> Vol. apport jour :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj180.vision"> {{ (detail.volumeApportJour
          ? common.toFixed(detail.volumeApportJour) :
          default.toFixed(nbdigit)) }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.volumeApportJour" [hidden]="!common.visibleChamp.cltObj180.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj180.creation) || (!add && edit && !common.visibleChamp.cltObj180.modifiable)">
      </div>
    </div>
    <!--  Champs fiche client n'apparaissent pas (point : 116718)  -->
    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt223">
      <label class="col-sm-3 champ" style="padding:0px"> Vol. apport semaine :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj223.vision">
          {{ detail.volumeApportSemaine }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="number" class="form-control"
          [(ngModel)]="detail.volumeApportSemaine" [hidden]="!common.visibleChamp.cltObj223.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj223.creation) || (!add && edit && !common.visibleChamp.cltObj223.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt216">
      <label class="col-sm-3 champ" style="padding:0px"> Vol. apport année :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj216.vision">
          {{ detail.volumeApportAn }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="number" class="form-control"
          [(ngModel)]="detail.volumeApportAn" [hidden]="!common.visibleChamp.cltObj216.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj216.creation) || (!add && edit && !common.visibleChamp.cltObj216.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt219">
      <label class="col-sm-3 champ" style="padding:0px"> Nbr apport Jour :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj219.vision">
          {{ detail.nbrApportJour }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="number" class="form-control"
          [(ngModel)]="detail.nbrApportJour" [hidden]="!common.visibleChamp.cltObj219.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj219.creation) || (!add && edit && !common.visibleChamp.cltObj219.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt220">
      <label class="col-sm-3 champ" style="padding:0px"> Nbr apport Semaine :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj220.vision">
          {{ detail.nbrApportSemaine }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="number"
          [hidden]="!common.visibleChamp.cltObj220.vision" class="form-control" [(ngModel)]="detail.nbrApportSemaine"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj220.creation) || (!add && edit && !common.visibleChamp.cltObj220.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt221">
      <label class="col-sm-3 champ" style="padding:0px"> Nbr apport Mois :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj221.vision">
          {{ detail.nbrApportMois }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="number" class="form-control"
          [(ngModel)]="detail.nbrApportMois" [hidden]="!common.visibleChamp.cltObj221.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj221.creation) || (!add && edit && !common.visibleChamp.cltObj221.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt222">
      <label class="col-sm-3 champ" style="padding:0px"> Nbr apport An :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj222.vision">
          {{ detail.nbrApportAnnee }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.nbrApportAnnee" [hidden]="!common.visibleChamp.cltObj222.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj222.creation) || (!add && edit && !common.visibleChamp.cltObj222.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt2">
      <label class="col-sm-3 champ" style="padding:0px">Civilité Fact :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <!-- <div  [ngClass]="{'disabledbutton': detail.prospectHolding }"  *ngIf="!edit">{{ civilite }}</div> -->
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj2.vision">
          {{ (detail.civiliteFact ? detail.civiliteFact.libelle || civiliteFact : 'Aucune') }}
        </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding, 'disabledbutton': (add && !common.visibleChamp.cltObj2.creation) || (!add && edit && !common.visibleChamp.cltObj2.modifiable) }"
          *ngIf="edit">
          <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj2.vision">
            <app-autocomplete (searchfunction)="searchCivilite($event)"
              (selectfunction)="detail.civiliteFact = $event; change.cltObj2 = true;" [results]="listCivilite"
              [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.civiliteFact"
              [disablefocus]="true"
              [defaultsearch]="common.visibleChamp.cltObj2.vision || (!common.visibleChamp.cltObj2.vision && change.cltObj2) ? (detail.civiliteFact ? detail.civiliteFact.libelle : 'Aucune') : ''">
            </app-autocomplete>
          </div>
          <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj2.vision">
            {{ (detail.civiliteFact ? detail.civiliteFact.libelle : 'Aucune') }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt15">
      <label class="col-sm-3 champ" style="padding:0px">Nom fact :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj15.vision">
          {{ detail.nomF }}</div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.nomF" [hidden]="!common.visibleChamp.cltObj15.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj15.creation) || (!add && edit && !common.visibleChamp.cltObj15.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="(common.visibleChamp.clt16 && common.visibleChamp.cltObj16.vision) ||
             (common.visibleChamp.clt17 && common.visibleChamp.cltObj17.vision) ||
              (common.visibleChamp.clt18 && common.visibleChamp.cltObj18.vision)">
      <label class="col-sm-3 champ" style="padding:0px"> Ad. F. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt16 && common.visibleChamp.cltObj16.vision)">
          {{ detail.adresse1F }}</div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt17 && common.visibleChamp.cltObj17.vision)">
          {{ detail.adresse2F }}</div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt18 && common.visibleChamp.cltObj18.vision)">
          {{ detail.adresse3F }}</div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt16 && !common.visibleChamp.cltObj16.vision)">

        </div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt17 && !common.visibleChamp.cltObj17.vision)">

        </div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt18 && !common.visibleChamp.cltObj18.vision)">

        </div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit">
          <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj16.vision"
            [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj16.creation) || (!add && edit && !common.visibleChamp.cltObj16.modifiable) }">
            <app-autocomplete [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="adresseAutoBAK"
              [placeholder]="'Adresse'" (searchfunction)="searchAdresseBAK($event)"
              (selectfunction)="setValueAdresseBAK($event, 'adF')" [results]="dataAdresseBAK" [container]="true"
              [defaultsearch]="detail.adresse1F ? detail.adresse1F : ''" [minlength]="3" [activeVisibleChamp]="true"
              [visibleChamp]="common.visibleChamp.cltObj16.vision" [nePasCompterEspace]="true">
            </app-autocomplete>
          </div>
          <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj16.vision">
            {{ (detail.adresse1F ? detail.adresse1F : '')
            }}
          </div>
          <input [ngClass]="{'disabledbutton': detail.prospectHolding }"
            *ngIf="edit && (common.visibleChamp.clt16) && !adresseAutoBAK" type="text" class="form-control"
            [(ngModel)]="detail.adresse1F" [readonly]="adresseAutoBAK" [hidden]="!common.visibleChamp.cltObj16.vision"
            [disabled]="!droit.droitFicheGen||
                        (add && !common.visibleChamp.cltObj16.creation) || (!add && edit && !common.visibleChamp.cltObj16.modifiable)">
        </div>

        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && (common.visibleChamp.clt17)"
          type="text" class="form-control" [(ngModel)]="detail.adresse2F" [readonly]="adresseAutoBAK"
          style="margin-top: 5px; margin-bottom: 5px;" [hidden]="!common.visibleChamp.cltObj17.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj17.creation) || (!add && edit && !common.visibleChamp.cltObj17.modifiable)">
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && (common.visibleChamp.clt18)"
          type="text" class="form-control" [(ngModel)]="detail.adresse3F" [readonly]="adresseAutoBAK"
          [hidden]="!common.visibleChamp.cltObj18.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj18.creation) || (!add && edit && !common.visibleChamp.cltObj18.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt19">
      <label class="col-sm-3 champ" style="padding:0px"> CP F. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj19.vision">
          {{ detail.cpF }} </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding||
                (add && !common.visibleChamp.cltObj19.creation) || (!add && edit && !common.visibleChamp.cltObj19.modifiable) }"
          *ngIf="edit">
          <app-autocomplete-cp-ville [cp]="'cpF'" [item]="detail" [ville]="'villeF'" [iscp]="true"
            [deleteSelectedValue]="true" [disable]="adresseAutoBAK || !droit.droitFicheGen" [activeVisibleChamp]="true"
            [visibleChamp]="common.visibleChamp.cltObj19.vision">
          </app-autocomplete-cp-ville>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt20">
      <label class="col-sm-3 champ" style="padding:0px"> Ville F. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj20.vision">
          {{ detail.villeF }} </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding||
                (add && !common.visibleChamp.cltObj20.creation) || (!add && edit && !common.visibleChamp.cltObj20.modifiable) }"
          *ngIf="edit">
          <app-autocomplete-cp-ville [cp]="'cpF'" [item]="detail" [ville]="'villeF'" [deleteSelectedValue]="true"
            [disable]="adresseAutoBAK || !droit.droitFicheGen" [activeVisibleChamp]="true"
            [visibleChamp]="common.visibleChamp.cltObj20.vision">
          </app-autocomplete-cp-ville>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt21">
      <label class="col-sm-3 champ" style="padding:0px"> Pays F.:</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj21.vision">
          {{ paysF }} </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding||
                (add && !common.visibleChamp.cltObj21.creation) || (!add && edit && !common.visibleChamp.cltObj21.modifiable) }"
          *ngIf="edit">
          <div *ngIf="droit.droitFicheGen  && common.visibleChamp.cltObj21.vision ">
            <app-autocomplete (searchfunction)="searchPays($event)" [deleteSelectedValue]="true"
              (selectfunction)="detail.paysF = $event; paysF = $event.libelle;" [results]="listPays" [highlight]="true"
              [id]="'modedepaie'" [selectvalue]="true" [disablefocus]="true" [defaultselected]="detail.paysF"
              [defaultsearch]="detail.paysF ? detail.paysF.libelle : ''">
            </app-autocomplete>
          </div>
          <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj21.vision">
            {{ (detail.paysF ? detail.paysF.libelle : '')
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt185">
      <label class="col-sm-3 champ" style="padding:0px"> Nom Envoi :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj185.vision">
          {{ (detail.nomEnvoie) }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text"
          [hidden]="!common.visibleChamp.cltObj185.vision" class="form-control" [(ngModel)]="detail.nomEnvoie"
          [disabled]="!droit.droitFicheGen ||
                    (add && !common.visibleChamp.cltObj185.creation) || (!add && edit && !common.visibleChamp.cltObj185.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="(common.visibleChamp.clt186) ||
             (common.visibleChamp.clt187) ||
              (common.visibleChamp.clt188)">
      <label class="col-sm-3 champ" style="padding:0px"> Ad E :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt186 && common.visibleChamp.cltObj186.vision)">
          {{ detail.adresse1Envoie }}</div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt187 && common.visibleChamp.cltObj187.vision)">
          {{ detail.adresse2Envoie }}</div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt188 && common.visibleChamp.cltObj188.vision)">
          {{ detail.adresse3Envoie }}</div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt186 && !common.visibleChamp.cltObj186.vision)">

        </div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt187 && !common.visibleChamp.cltObj187.vision)">

        </div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && (common.visibleChamp.clt188 && !common.visibleChamp.cltObj188.vision)">

        </div>
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit">
          <div *ngIf="droit.droitFicheGen  && common.visibleChamp.cltObj186.vision"
            [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj186.creation) || (!add && edit && !common.visibleChamp.cltObj186.modifiable) }">
            <app-autocomplete [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="adresseAutoBAK"
              [placeholder]="'Adresse'" (searchfunction)="searchAdresseBAK($event)"
              (selectfunction)="setValueAdresseBAK($event, 'adE')" [results]="dataAdresseBAK" [container]="true"
              [defaultsearch]="detail.adresse1Envoie ? detail.adresse1Envoie : ''" [minlength]="3"
              [activeVisibleChamp]="true" [visibleChamp]="common.visibleChamp.cltObj186.vision"
              [nePasCompterEspace]="true">
            </app-autocomplete>
          </div>
          <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj186.vision">
            {{ (detail.adresse1Envoie ? detail.adresse1Envoie : '') }}
          </div>
          <input [ngClass]="{'disabledbutton': detail.prospectHolding }"
            [hidden]="!common.visibleChamp.cltObj186.vision"
            *ngIf="edit && (common.visibleChamp.clt186) && !adresseAutoBAK" type="text" class="form-control"
            [(ngModel)]="detail.adresse1Envoie"
            [disabled]="!droit.droitFicheGen||
                        (add && !common.visibleChamp.cltObj186.creation) || (!add && edit && !common.visibleChamp.cltObj186.modifiable)">
        </div>
        <!--input  [ngClass]="{'disabledbutton': detail.prospectHolding }"  *ngIf="edit && common.visibleChamp.clt186" type="text" class="form-control" [(ngModel)]="detail.adresse1Envoie" [readonly]="adresseAutoBAK"-->
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && (common.visibleChamp.clt187)"
          type="text" [hidden]="!common.visibleChamp.cltObj187.vision" class="form-control"
          [(ngModel)]="detail.adresse2Envoie" [readonly]="adresseAutoBAK" style="margin-top: 5px; margin-bottom: 5px;"
          [disabled]="!droit.droitFicheGen ||
                    (add && !common.visibleChamp.cltObj187.creation) || (!add && edit && !common.visibleChamp.cltObj187.modifiable)">
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit && (common.visibleChamp.clt188)"
          type="text" [hidden]="!common.visibleChamp.cltObj188.vision" class="form-control"
          [(ngModel)]="detail.adresse3Envoie" [readonly]="adresseAutoBAK"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj188.creation) || (!add && edit && !common.visibleChamp.cltObj188.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt189">
      <label class="col-sm-3 champ" style="padding:0px"> CP E. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj189.vision">
          {{ detail.cpEnvoie }} </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding||
                (add && !common.visibleChamp.cltObj189.creation) || (!add && edit && !common.visibleChamp.cltObj189.modifiable) }"
          *ngIf="edit">
          <app-autocomplete-cp-ville [cp]="'cpEnvoie'" [item]="detail" [ville]="'villeEnvoie'" [iscp]="true"
            [disable]="adresseAutoBAK || !droit.droitFicheGen" [activeVisibleChamp]="true"
            [visibleChamp]="common.visibleChamp.cltObj189.vision">
          </app-autocomplete-cp-ville>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt200">
      <label class="col-sm-3 champ" style="padding:0px">Ville E. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj200.vision">
          {{ detail.villeEnvoie }}
        </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding||
                (add && !common.visibleChamp.cltObj200.creation) || (!add && edit && !common.visibleChamp.cltObj200.modifiable) }"
          *ngIf="edit">
          <app-autocomplete-cp-ville [cp]="'cpEnvoie'" [item]="detail" [ville]="'villeEnvoie'"
            [disable]="adresseAutoBAK || !droit.droitFicheGen" [activeVisibleChamp]="true"
            [visibleChamp]="common.visibleChamp.cltObj200.vision">
          </app-autocomplete-cp-ville>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt201">
      <label class="col-sm-3 champ" style="padding:0px"> Pays E :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj201.vision">
          {{ paysEnvoie }} </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding||
                (add && !common.visibleChamp.cltObj201.creation) || (!add && edit && !common.visibleChamp.cltObj201.modifiable) }"
          *ngIf="edit">
          <app-autocomplete [placeholder]="''" (searchfunction)="searchPays($event)"
            (selectfunction)="detail.paysEnvoie = $event; paysEnvoie = $event.libelle" [results]="listPays"
            [highlight]="true" [id]="'modedepaie'" [defaultselected]="detail.paysEnvoie" [selectvalue]="true"
            [disablefocus]="true" [defaultsearch]="detail.paysEnvoie ? detail.paysEnvoie.libelle : ''">
          </app-autocomplete>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt27">
      <label class="col-sm-3 champ" style="padding:0px"> Resp. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj27.vision">
          {{detail.responsable }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.responsable" [hidden]="!common.visibleChamp.cltObj27.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj27.creation) || (!add && edit && !common.visibleChamp.cltObj27.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt28">
      <label class="col-sm-3 champ" style="padding:0px"> Tel Resp. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj28.vision">
          {{ detail.telephoneResponsable }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.telephoneResponsable" [hidden]="!common.visibleChamp.cltObj28.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj28.creation) || (!add && edit && !common.visibleChamp.cltObj28.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt32">
      <label class="col-sm-3 champ" style="padding:0px">Port. Resp :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj32.vision">
          {{ detail.portableResponsable }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.portableResponsable" [hidden]="!common.visibleChamp.cltObj32.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj32.creation) || (!add && edit && !common.visibleChamp.cltObj32.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt29">
      <label class="col-sm-3 champ" style="padding:0px"> Mail Resp. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj29.vision">
          {{ detail.mailResponsable }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.mailResponsable" (keydown)="common.filterCarracterEmail($event)"
          [hidden]="!common.visibleChamp.cltObj29.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj29.creation) || (!add && edit && !common.visibleChamp.cltObj29.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt30">
      <label class="col-sm-3 champ" style="padding:0px"> Fax Resp. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj30.vision">
          {{ detail.faxResponsable }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.faxResponsable" [hidden]="!common.visibleChamp.cltObj30.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj30.creation) || (!add && edit && !common.visibleChamp.cltObj30.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt31">
      <label class="col-sm-3 champ" style="padding:0px"> Mail Env Fact. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj31.vision" style="    white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            overflow: hidden;">
          {{ detail.mailFacturation }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.mailFacturation" (keydown)="common.filterCarracterEmail($event)"
          [hidden]="!common.visibleChamp.cltObj31.vision"
          [disabled]="!droit.droitFicheGen||
                    (add && !common.visibleChamp.cltObj31.creation) || (!add && edit && !common.visibleChamp.cltObj31.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt171">
      <label class="col-sm-3 champ" style="padding:0px"> Ad Env Mail :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj171.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px" (click)="openAdEnvMail()"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj171.creation) || (!add && edit && !common.visibleChamp.cltObj171.modifiable) }">
        Définir
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt22">
      <label class="col-sm-3 champ" style="padding:0px"> Activité :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj22.vision">
          {{ (detail.activites ? detail.activites.libelle : '') }}
        </div>
        <div
          [ngClass]="{'disabledbutton': detail.prospectHolding || (add && !common.visibleChamp.cltObj22.creation) || (!add && edit && !common.visibleChamp.cltObj22.modifiable) }"
          *ngIf="edit">
          <div *ngIf="droit.droitFicheGen">
            <app-autocomplete (searchfunction)="searchActivite($event)" (selectfunction)="detail.activites = $event"
              [results]="listActivite" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
              [defaultselected]="detail.activites" [disablefocus]="true"
              [defaultsearch]="detail.activites ? detail.activites.libelle : ''">
            </app-autocomplete>
          </div>
          <div *ngIf="!droit.droitFicheGen && common.visibleChamp.cltObj22.vision">
            {{ (detail.activites ? detail.activites.libelle : '') }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt23">
      <label class="col-sm-3 champ" style="padding:0px"> Autre Act. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj23.vision">
          {{ detail.activite }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text"
          [hidden]="!common.visibleChamp.cltObj23.vision" class="form-control" [(ngModel)]="detail.activite"
          [disabled]="!droit.droitFicheGen || (add && !common.visibleChamp.cltObj23.creation) || (!add && edit && !common.visibleChamp.cltObj23.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt24">
      <label class="col-sm-3 champ" style="padding:0px"> APE :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj24.vision">
          {{ detail.ape }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [(ngModel)]="detail.ape" [hidden]="!common.visibleChamp.cltObj24.vision"
          [disabled]="!droit.droitFicheGen || (add && !common.visibleChamp.cltObj24.creation) || (!add && edit && !common.visibleChamp.cltObj24.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt33">
      <label class="col-sm-3 champ" style="padding:0px"> Garage :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <input *ngIf="common.visibleChamp.cltObj33.vision" type="checkbox" id="checkbox-1-1 "
          class="regular-checkbox regular-checkbox-checked"
          [disabled]="!edit || !droit.droitFicheGen || (add && !common.visibleChamp.cltObj33.creation) || (!add && edit && !common.visibleChamp.cltObj33.modifiable)"
          [(ngModel)]="detail.isGarage">

      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt33">
      <label class="col-sm-3 champ" style="padding:0px"> Code Auto Eco. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj33.vision">
          {{ (detail.isGarage ? detail.codeAutoEco : '') }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text"
          [hidden]="!common.visibleChamp.cltObj33.vision" class="form-control" [disabled]="!detail.isGarage"
          [(ngModel)]="detail.codeAutoEco"
          [disabled]="!droit.droitFicheGen || (add && !common.visibleChamp.cltObj33.creation) || (!add && edit && !common.visibleChamp.cltObj33.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt33">
      <label class="col-sm-3 champ" style="padding:0px"> Marque :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px"
        [ngClass]="{'disabledbutton':  (add && !common.visibleChamp.cltObj33.creation) || (!add && edit && !common.visibleChamp.cltObj33.modifiable) }">

      </div>
    </div>
  </ng-template>
  <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
    *ngIf="common.visibleChamp.clt38">
    <ng-template [ngIf]="!detail.prospect">
      <label class="col-sm-3 champ" style="padding:0px"> Visibilité :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj38.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px" (click)="openVisibilite()"
        [ngClass]="{'disabledbutton':  (add && !common.visibleChamp.cltObj38.creation) || (!add && edit && !common.visibleChamp.cltObj38.modifiable) }">
        Définir
      </div>
    </ng-template>

  </div>
  <ng-template [ngIf]="!isInfoPart">
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt47">
      <label class="col-sm-3 champ" style="padding:0px">Contact :</label>
      <div class="col-sm-9 champ text-underline historique"
        *ngIf="!detail.prospectHolding && droit.droitFicheGen && common.visibleChamp.cltObj47.vision"
        style="padding-right: 0px"
        [ngClass]="{'disabledbutton': add || (add && !common.visibleChamp.cltObj47.creation) || (!add && edit && !common.visibleChamp.cltObj47.modifiable)}"
        (click)="showListContact()">
        Afficher
      </div>
      <div class="col-sm-9 champ text-underline historique"
        *ngIf="detail.prospectHolding && droit.droitFicheGen && common.visibleChamp.cltObj47.vision"
        [ngClass]="{'disabledbutton':  add || (add && !common.visibleChamp.cltObj47.creation) || (!add && edit && !common.visibleChamp.cltObj47.modifiable)}"
        style="padding-right: 0px" (click)="showListContact()">
        Afficher
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt204">
      <label class="col-sm-3 champ" style="padding:0px"> Logo :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj204.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
        [ngClass]="{'disabledbutton':  (add && !common.visibleChamp.cltObj204.creation) || (!add && edit && !common.visibleChamp.cltObj204.modifiable)}"
        (click)="openLogo()">
        Définir
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt39">
      <label class="col-sm-3 champ" style="padding:0px"> Client EcoEnv. :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <input type="checkbox" *ngIf="common.visibleChamp.cltObj39.vision" id="checkbox-1-1 "
          class="regular-checkbox regular-checkbox-checked"
          [disabled]="!edit || !droit.droitFicheGen || (add && !common.visibleChamp.cltObj39.creation) || (!add && edit && !common.visibleChamp.cltObj39.modifiable)"
          [(ngModel)]="detail.isEcoEnvironnement">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt214">
      <label class="col-sm-3 champ" style="padding:0px"> User EcoPortail :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj214.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
        [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj214.creation) || (!add && edit && !common.visibleChamp.cltObj214.modifiable)}"
        (click)="showListUserEcoportail()">
        Afficher
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt215">
      <label class="col-sm-3 champ" style="padding:0px"> Droits EcoPortail :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj215.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj215.creation) || (!add && edit && !common.visibleChamp.cltObj215.modifiable) }"
        (click)="openDroitEcoPortail()">
        Définir
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt215">
      <label class="col-sm-3 champ" style="padding:0px"> Acces widget :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj215.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj215.creation) || (!add && edit && !common.visibleChamp.cltObj215.modifiable) }"
        (click)="openAccesWidgetEcoPortail()">
        Définir
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt227">
      <label class="col-sm-3 champ" style="padding:0px"> Documents :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj227.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
        [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj227.creation) || (!add && edit && !common.visibleChamp.cltObj227.modifiable)}"
        (click)="showListDocument()">
        Afficher
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt167 && societe.gestionFIP">
      <label class="col-sm-3 champ" style="padding:0px"> FIP DND :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj167.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
        [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj167.creation) || (!add && edit && !common.visibleChamp.cltObj167.modifiable)}"
        (click)="showFIPDND()">
        Définir
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt168 && societe.gestionFIP">
      <label class="col-sm-3 champ" style="padding:0px"> FIP DD :</label>
      <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj168.vision"
        class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
        [ngClass]="{'disabledbutton': !edit || add || (add && !common.visibleChamp.cltObj168.creation) || (!add && edit && !common.visibleChamp.cltObj168.modifiable)}"
        (click)="showFIPDD()">
        Définir
      </div>
    </div>


    <div class="form-group items col-sm-12">
      <label class="col-sm-3 champ" style="padding:0px"> Non soumis FIP :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
          [disabled]="!edit || !droit.droitFicheGen" [(ngModel)]="detail.isNonSoumisFIP">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt181">
      <label class="col-sm-3 champ" style="padding:0px"> Entreprise de travaux :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div class="col-sm-12 champ" style="padding: 0px">
          <input type="checkbox" id="checkbox-1-1 " *ngIf="common.visibleChamp.cltObj181.vision"
            class="regular-checkbox regular-checkbox-checked" [disabled]="!edit || !droit.droitFicheGen"
            [(ngModel)]="detail.entrepriseTravaux">
        </div>
        <div *ngIf="droit.droitFicheGen && common.visibleChamp.cltObj181.vision"
          class="col-sm-12 champ text-underline historique" style="padding: 0px"
          [ngClass]="{'disabledbutton': !edit || !detail.entrepriseTravaux || add || (add && !common.visibleChamp.cltObj181.creation) || (!add && edit && !common.visibleChamp.cltObj181.modifiable)}"
          (click)="showListEntTrav()">
          Afficher
        </div>


      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt182">
      <label class="col-sm-3 champ" style="padding:0px"> Maitre d'ouvrage :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <input type="checkbox" *ngIf="common.visibleChamp.cltObj182.vision" id="checkbox-1-1 "
          class="regular-checkbox regular-checkbox-checked"
          [disabled]="!edit || !droit.droitFicheGen || (add && !common.visibleChamp.cltObj182.creation) || (!add && edit && !common.visibleChamp.cltObj182.modifiable)"
          [(ngModel)]="detail.maitreOuvrage">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt206">
      <label class="col-sm-3 champ" style="padding:0px"> Négociant :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <input type="checkbox" *ngIf="common.visibleChamp.cltObj206.vision" id="checkbox-1-1 "
          class="regular-checkbox regular-checkbox-checked"
          [disabled]="!edit || !droit.droitFicheGen ||(add && !common.visibleChamp.cltObj206.creation) || (!add && edit && !common.visibleChamp.cltObj206.modifiable)"
          [(ngModel)]="detail.isNegociant">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt206">
      <label class="col-sm-3 champ" style="padding:0px"> N° récépissé négociant :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj206.vision">
          {{ detail.recepisseNegociantClient }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text"
          [hidden]="!common.visibleChamp.cltObj206.vision" class="form-control"
          [(ngModel)]="detail.recepisseNegociantClient"
          [disabled]="!droit.droitFicheGen ||(add && !common.visibleChamp.cltObj206.creation) || (!add && edit && !common.visibleChamp.cltObj206.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt206">
      <label class="col-sm-3 champ" style="padding:0px"> Date valid. négociant :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj206.vision">
          {{ (detail.dateValiditeNegociantClient !== '31/12/9999' ? detail.dateValiditeNegociantClient : '') }}
        </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text" class="form-control"
          [readonly]="!detail.isNegociant" [hidden]="!common.visibleChamp.cltObj206.vision"
          [(ngModel)]="detail.dateValiditeNegociantClient"
          (ngModelChange)="common.changeDateFormat('dateValiditeNegociantClient', detail)"
          [disabled]="!droit.droitFicheGen ||(add && !common.visibleChamp.cltObj206.creation) || (!add && edit && !common.visibleChamp.cltObj206.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12" [ngClass]="{'disabledbutton': detail.prospectHolding }"
      *ngIf="common.visibleChamp.clt207">
      <label class="col-sm-3 champ" style="padding:0px"> Mail BSDD :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div [ngClass]="{'disabledbutton': detail.prospectHolding }"
          *ngIf="!edit && common.visibleChamp.cltObj207.vision">
          {{ (detail.mailBSDD) }} </div>
        <input [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="text"
          [hidden]="!common.visibleChamp.cltObj207.vision" class="form-control" [(ngModel)]="detail.mailBSDD"
          (keydown)="common.filterCarracterEmail($event)"
          [disabled]="!droit.droitFicheGen ||(add && !common.visibleChamp.cltObj207.creation) || (!add && edit && !common.visibleChamp.cltObj207.modifiable)">
      </div>
    </div>

    <div class="form-group items col-sm-12">
      <label class="col-sm-3 champ" style="padding:0px"> Code externe :</label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <div *ngIf="!edit">
          {{ (detail.codeExterne || '') }}
        </div>
        <input *ngIf="edit" type="text" [hidden]="!true" class="form-control" [(ngModel)]="detail.codeExterne">
      </div>
    </div>
  </ng-template>

  <div class="form-group items col-sm-12">
    <label class="col-sm-3 champ" style="padding:0px"> Dernière Modif :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <span [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="detail.log"> {{
        detail.log.derniereModification && detail.log.derniereModification.id > 0 ?
        (detail.log.derniereModification.date ? detail.log.derniereModification.date.slice(0, -9) : '') + ' ' +
        (detail.log.derniereModification.heure ? detail.log.derniereModification.heure.slice(0,
        -3) : '') : '' }}</span>
    </div>
  </div>
  <div class="form-group items col-sm-12">
    <label class="col-sm-3 champ" style="padding:0px"> Par :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <span [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="detail.log">{{
        detail.log.derniereModification && detail.log.derniereModification.id > 0 &&
        detail.log.derniereModification.user ?
        (detail.log.derniereModification.user.nom + ' ' + detail.log.derniereModification.user.prenom)
        : ''}}</span>

    </div>
  </div>
  <div class="form-group items col-sm-12">
    <label class="col-sm-3 champ" style="padding:0px"> Crée le :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <span [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="detail.log"> {{ detail.log.creation &&
        detail.log.creation.id
        > 0 ? detail.log.creation.date.slice(0, -9) + ' ' +
        detail.log.creation.heure.slice(0,
        -3) : '' }}</span>

    </div>
  </div>
  <div class="form-group items col-sm-12">
    <label class="col-sm-3 champ" style="padding:0px"> Par:</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <span [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="detail.log">{{ detail.log.creation &&
        detail.log.creation.id > 0 && detail.log.creation.user ? detail.log.creation.user.prenom + ' ' +
        detail.log.creation.user.nom : '' }}</span>
    </div>
  </div>

  <div class="form-group items col-sm-12">
    <label class="col-sm-3 champ" style="padding:0px"> SignatureAuto TD :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <mat-checkbox [color]="'primary'" [(ngModel)]="detail.isSignatureAutoTD" [disabled]="!edit">
      </mat-checkbox>
    </div>
  </div>
</div>

<ng-template #adEnvMail>
  <div>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Bon d'achat :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailBonAchat" [disabled]="!edit"
            (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Bon facturation :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailBonFacturation"
            [disabled]="!edit" (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Bon logistique :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailBonLogistique"
            [disabled]="!edit" (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Contrat :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailContrat" [disabled]="!edit"
            (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Devis :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailDevis" [disabled]="!edit"
            (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Facture :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailFacture" [disabled]="!edit"
            (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Rapport :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailRapport" [disabled]="!edit"
            (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Relance :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailRelance" [disabled]="!edit"
            (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px">
          Ticket de pesée :
        </label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <input type="text" class="form-control" [(ngModel)]="adresseDestClient.adresseMailTicketPesee"
            [disabled]="!edit" (keydown)="common.filterCarracterEmail($event)">
        </div>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="button"
        class=" btn-close btn-valider" (click)="validerAdEnvMail();common.closeModal();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #visibilite>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Visibilité du client : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="form-group items col-sm-12">
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [disabled]="!edit"
          [(ngModel)]="visibiliteValue" (ngModelChange)="changeVisibilite(visibiliteValue)">
          <mat-radio-button [color]="'primary'" class="example-radio-button" *ngFor="let item of choixVisibilite"
            [value]="item.id">
            {{item.libelle}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <label class="titre">Modules</label>
      <div class="form-group items col-sm-12 module">
        <div class="col-sm-6" *ngFor="let item of listModules">
          <mat-checkbox [color]="'primary'" [disabled]="!edit || visibiliteValue !== 3" [(ngModel)]="item.checked">
            {{ item.libelle }} </mat-checkbox>
        </div>
      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="button"
        class=" btn-close btn-valider" (click)="validerVisibilite();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #logo>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Définition de logo : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="col-sm-12" style="padding: 0 0 15px 15px;">
        <img [src]="cheminLogo" alt="{{ cheminLogo }}" style="max-width: 100%; width: auto; max-height: 300px;" />
      </div>
      <div class="col-sm-8">
        <input class="hide" id="input-file-societe" [disabled]="!edit" (change)="getNameFile($event)" type="file"
          accept="{{ common.extFichierImg }}" />
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="objFileObject.nom" readonly>
          <label class="input-group-addon" for="input-file-societe"><i class="fa fa-upload"></i> Parcourir
          </label>
        </div>
      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="button"
        class=" btn-close btn-valider" (click)="validerLogo();common.closeModal();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #droitEcoPortail>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Accès EcoPortail : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <!--div class="col-sm-12" style="padding: 0px;">
          <label class="col-sm-5 champ" style="padding:0px">
              Documents
          </label>
          <label class="col-sm-7 champ" style="padding:0px">
              Accès
          </label>
      </div-->
      <div class="col-sm-12" style="padding: 0px;    height: 300px; overflow: auto;">
         <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Documents :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isDocuments" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Bon :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isBon" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            BSDD :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isBSDD" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Facture :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isFacture" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Avoir :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isAvoir" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Bon Achat :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isBonAchat" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Avoir Achat :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isAvoirAchat" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Ticket Pesée :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isTicketPesee" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Devis :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isDevis" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            CAP :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isCAP" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            FIP :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isFIP" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
       
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Rapports :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isLibraData" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Commandes :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isPriseCommande" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Demandes :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isDemande" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Délai Commandes :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <input type="text" class="form-control" [(ngModel)]="droitEcoGED.delaiCommande" [disabled]="!edit">
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Envoi bon par mail :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isEnvoiBonParMail" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Génération Prog:
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isGenerationProg" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Validation realisation :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isValidationRealisation" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
            Attestation 8 flux :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isAttestation5Flux" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
           Taux remplissage demande bennes:
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">      
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isTauxRemplissage" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
           Etiquette ADR :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">      
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isEtiquetteADR" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
           Envoi mail pour refus de commande :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">      
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isEnvoiMailRefusCommande" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>

        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
           Envoi mail pour acceptation de commande :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">      
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isEnvoiMailAccepteCommande" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-4 champ" style="padding:0px">
            Texte demande contenant :
          </label>
          <div class="col-sm-8 champ" style="padding-right: 3px">
              <textarea class="form-control" style="padding: 10px;" [(ngModel)]="droitEcoGED.texteDemandeContenant" [disabled]="!edit" maxlength="512" rows="4" ></textarea>
          </div>
        </div>
        <div class="form-group items mt-1 col-sm-12">
          <label class="col-sm-4 champ" style="padding:0px">
            
          </label>
          <div class="col-sm-8 champ" style="padding-right: 0px">
            <button type="button" class=" btn-close btn-valider" style="width: 270px ! important" (click)="openModalOperationBenne();"
              [disabled]="!edit">
              Définir les opérations de bennes </button>
          </div>
        </div>
        <div class="form-group items col-sm-12">
          <label class="col-sm-4 champ" style="padding:0px">
            Nbr Max Mouv/Contenant/Jour :
          </label>
          <div class="col-sm-8 champ" style="padding-right: 3px">
            <input type="text" class="form-control" [(ngModel)]="droitEcoGED.nbrMaxMouvContenantJour" [disabled]="!edit">       
          </div>
        </div>

        <div class="form-group items col-sm-12">
          <label class="col-sm-6 champ" style="padding:0px">
           Images visibles dans la PAF :
          </label>
          <div class="col-sm-6 champ" style="padding-right: 0px">      
            <mat-checkbox [color]="'primary'" [(ngModel)]="droitEcoGED.isImagePAF" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>

      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="button"
        class=" btn-close btn-valider" (click)="ValiderDroitEcoPortail();common.closeModal();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #accesWidgetEcoPortail>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Accès widget : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="col-sm-12" style="padding: 0px; height: 300px; overflow: auto;">
        <div class="form-group items col-sm-12 row-widget-ecoportail"
          *ngFor="let assoClientWidgetEcoPortail of listeAssoClientWidgetEcoPortailTmp">
          <label class="col-sm-10 champ" style="padding:0px">
            {{ assoClientWidgetEcoPortail.widgetEcoPortail && assoClientWidgetEcoPortail.widgetEcoPortail ?
            assoClientWidgetEcoPortail.widgetEcoPortail.titre : '' }} :
          </label>
          <div class="col-sm-2 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="assoClientWidgetEcoPortail.isVisible" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="button"
        class=" btn-close btn-valider" (click)="validerAccesWidgetEcoPortail();common.closeModal();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>


<ng-template #choixOperationBennePortail>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Opérations benne  : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="col-sm-12" style="padding: 0px; height: 300px; overflow: auto;">
        <div class="form-group items col-sm-12 row-widget-ecoportail">
          <div class="col-sm-8 champ" style="padding-right: 0px;padding-left: 0px;">
            Opération
          </div>
          <div class="col-sm-4 champ" style="padding-right: 0px">
            Visible
          </div>
        </div>
        <div class="form-group items col-sm-12 row-widget-ecoportail"
          *ngFor="let opBennePortail of listOperationBennePortail">
          <label class="col-sm-8 champ" style="padding:0px">
            {{ opBennePortail.libelle || "" }} :
          </label>
          <div class="col-sm-4 champ" style="padding-right: 0px">
            <mat-checkbox [color]="'primary'" [(ngModel)]="opBennePortail.operationBenneVisiblePortailClient" [disabled]="!edit">
            </mat-checkbox>
          </div>
        </div>
      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button [ngClass]="{'disabledbutton': detail.prospectHolding }" *ngIf="edit" type="button"
        class=" btn-close btn-valider" (click)="validerAccesOperationBennePortail();common.closeModal();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler</button>
    </div>
  </div>
</ng-template>